import React from "react";
import SiteHeader from "../HomePage/SiteHeader";
import SiteFooter from "./SiteFooter";

const PublicLayout = ({ children }) => (
  <>
    <SiteHeader />
    <main style={{ minHeight: "60vh" }}>
      {children}
    </main>
    <SiteFooter />
  </>
);

export default PublicLayout;
